

















import { FetchState } from "@/shared/types";
import moment from "moment";
import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

const formatDate = v => moment.utc(v).format("MMM D, YYYY");

@Component({
  components: { }
})
export default class DayTradeListing extends Vue {

  drivewealthStore = useDrivewealthStore();

  @Prop({required: false})
  username: string;

  @Prop({required: false})
  partnerId: number;

  @Watch("$props", { deep: true })
    loadChart () {
      this.drivewealthStore.loadDayTrades({ username: this.username, partnerId: this.partnerId });
  }
  created () {
    this.drivewealthStore.loadDayTrades({ username: this.username, partnerId: this.partnerId });
  }

  get day_trades () {
    if (this.drivewealthStore.dayTrade.items === null) {
      return [];
    }

    return this.drivewealthStore.dayTrade.items.map(v => ({
      symbol: v.symbol,
      tradeDate: formatDate(v.tradeDate),
      direction: v.direction
    }));
  }

  get loaded () {
    return this.drivewealthStore.dayTrade.fetchState === FetchState.Loaded;
  }

  get zeroTrades () {
    return this.drivewealthStore.dayTrade.items !== null
        && this.drivewealthStore.dayTrade.items.length === 0;
  }
}
